import { 
        CREATEOPDOUTBILL,
        CREATEOPDOUTCOBORBIDITY,
        CREATEOPDOUTINVESTIGATION,
        CREATEOPDOUTSYMPTOMS,
        CREATEOPDVISITS,
        DELETEOPDOUTBILL, 
        DELETEOPDOUTCOBORBIDITY, 
        DELETEOPDOUTINVESTIGATION, 
        DELETEOPDOUTSYMPTOMS, 
        DELETEOPDVISITS, 
        GETALLOPDOUTBILL, 
        GETALLOPDVISITS, 
        GETOPDOUTBILL, 
        GETOPDOUTCOBORBIDITY, 
        GETOPDOUTINVESTIGATION, 
        GETOPDOUTSYMPTOMS, 
        GETOPDVISITS, 
        UPDATEOPDOUTBILL, 
        UPDATEOPDOUTCOBORBIDITY, 
        UPDATEOPDOUTINVESTIGATION, 
        UPDATEOPDOUTSYMPTOMS, 
        UPDATEOPDVISITS,
        DETAILSOPDVISITS,
        DETAILSOPDPRESCRIPTION,
        GETALLOPDOUTINVESTIGATION,
        DELETEOPDIMANGING,
        UPDATEOPDIMANGING,
        GETOPDIMANGING,
        CREATEOPDIMANGING,
 } from '../actions/types';

const initialState = {
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {

    switch (action.type) {
    case GETOPDVISITS:
            return {
                    ...state,
                    opdvisitsList: action.payload.data,
                    }
    case GETALLOPDVISITS:
            return {
                    ...state,
                    allopdvisitsList: action.payload.data,
                    }
    case DETAILSOPDVISITS:
            return {
                    ...state,
                    detailsopdvisitsList: action.payload.data,
                    }
    case DETAILSOPDPRESCRIPTION:
                        return {
                                ...state,
                                detailsopdprescriptionList: action.payload.data,
                                }
                    
    case UPDATEOPDVISITS:
            return {
                    ...state,
                    opdvisitsUpdateStatus: action.payload.success,
                    }   

    case DELETEOPDVISITS:
             return {
                 ...state,
                 opdvisitsDeleteStatus: action.payload.success,
                    } 
   case CREATEOPDVISITS:
            return {
                ...state,
            opdvisitsSaveStatus: action.payload.success,
            }
  case CREATEOPDOUTBILL:
            return {
                ...state,
            opdoutbillSaveStatus: action.payload.success,
            }
    case GETOPDOUTBILL:
            return {
                    ...state,
                    opdoutbillList: action.payload.data,
                    }
    case UPDATEOPDOUTBILL:
            return {
                    ...state,
                    opdoutbillUpdateStatus: action.payload.success,
                    }   

    case DELETEOPDOUTBILL:
             return {
                 ...state,
                 opdoutbillDeleteStatus: action.payload.success,
                    } 
    case GETALLOPDOUTBILL:
                return {
                        ...state,
                        allopdoutbillList: action.payload.data,
                        }
   case CREATEOPDOUTSYMPTOMS:
            return {
                ...state,
            opdoutsymptomsSaveStatus: action.payload.success,
            }
    case GETOPDOUTSYMPTOMS:
            return {
                    ...state,
                    opdoutsymptomsList: action.payload.data,
                    }
    case UPDATEOPDOUTSYMPTOMS:
            return {
                    ...state,
                    opdoutsymptomsUpdateStatus: action.payload.success,
                    }   

    case DELETEOPDOUTSYMPTOMS:
             return {
                 ...state,
                 opdoutsymptomsDeleteStatus: action.payload.success,
                    } 
    
   case CREATEOPDOUTCOBORBIDITY:
            return {
                ...state,
            opdoutcomorbiditySaveStatus: action.payload.success,
            }
    case GETOPDOUTCOBORBIDITY:
            return {
                    ...state,
                    opdoutcomorbidityList: action.payload.data,
                    }
    case UPDATEOPDOUTCOBORBIDITY:
            return {
                    ...state,
                    opdoutcomorbidityUpdateStatus: action.payload.success,
                    }   

    case DELETEOPDOUTCOBORBIDITY:
             return {
                 ...state,
                 opdoutcomorbidityDeleteStatus: action.payload.success,
                    } 
    case CREATEOPDOUTINVESTIGATION:
            return {
                ...state,
            opdoutinvestigationSaveStatus: action.payload.success,
            }
    case GETOPDOUTINVESTIGATION:
            return {
                    ...state,
                    opdoutinvestigationList: action.payload.data,
                    }
    case UPDATEOPDOUTINVESTIGATION:
            return {
                    ...state,
                    opdoutinvestigationUpdateStatus: action.payload.success,
                    }   

    case DELETEOPDOUTINVESTIGATION:
             return {
                 ...state,
                 opdoutinvestigationDeleteStatus: action.payload.success,
                    } 
   case CREATEOPDIMANGING:
            return {
                ...state,
            opdimangingSaveStatus: action.payload.success,
            }
    case GETOPDIMANGING:
            return {
                    ...state,
                    opdimangingList: action.payload.data,
                    }
    case UPDATEOPDIMANGING:
            return {
                    ...state,
                    opdimangingUpdateStatus: action.payload.success,
                    }   

    case DELETEOPDIMANGING:
             return {
                 ...state,
                 opdimangingDeleteStatus: action.payload.success,
                    } 
   
    
                    default:
                        return state
                         }

                     }